import controller from '../../../../Scripts/Controller.js';
function ModalController(container) {

    function init() {

        const modalButton = container.querySelector('#button-modal');
        const modalWrap = container.querySelector('#modal-wrap');

        // When the user clicks the button, open the modal 
        modalButton.onclick = function () {
            modalWrap.style.display = "block";
        }

        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function (event) {
            if (event.target == modalWrap) {
                modalWrap.style.display = "none";
            }
        }
    }

    return {
        init: init
    }

}

controller.add('ModalController', ModalController);
export default ModalController;